import { List, Create, Edit, View, MyPreSanction, Copy, Amendment } from "../Components/index.js";

export default [
    {
        path: "/voucher/account/my-pre-sanction",
        component: MyPreSanction,
        name: "account.voucher.my.pre-sanction",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/pre-sanction",
        component: List,
        name: "account.voucher.pre-sanction",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/pre-sanction/create",
        component: Create,
        name: "account.voucher.pre-sanction.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/pre-sanction/:id/edit",
        component: Edit,
        name: "account.voucher.pre-sanction.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/pre-sanction/:id/view",
        component: View,
        name: "account.voucher.pre-sanction.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/pre-sanction/:id/copy",
        component: Copy,
        name: "account.voucher.pre-sanction.copy",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/account/pre-sanction/:id/amendment",
        component: Amendment,
        name: "account.voucher.pre-sanction.amendment",
        meta: {
            requiresAuth: true,
        },
    },
];
